export default __webpack_public_path__ + "media/images/icons/arrow-right-2db90993a0432805e2a327a4c6098d1e.svg";